import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";

import testimonial1 from "../img/testimonial-1.jpg";
import testimonial2 from "../img/testimonial-2.jpg";
import testimonial3 from "../img/testimonial-3.jpg";
import testimonial4 from "../img/testimonial-4.jpg";

const TestimonialCard = ({ image, name, title, text }) => (
  <div className="testimonial-item border p-4 rounded">
    <div className="d-flex align-items-center">
      <img
        src={image}
        alt={name}
        className="rounded-circle"
        style={{ width: 70, height: 70, objectFit: "cover" }}
      />
      <div className="ms-4">
        <h4 className="text-secondary">{name}</h4>
        <p className="m-0 pb-3">{title}</p>
        <div className="d-flex pe-5">
          {[...Array(5)].map((_, i) => (
            <i key={i} className="fas fa-star me-1 text-primary"></i>
          ))}
        </div>
      </div>
    </div>
    <div className="border-top mt-4 pt-3">
      <p className="mb-0">{text}</p>
    </div>
  </div>
);

const Testimonial = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const testimonials = [
    {
      image: testimonial1,
      name: "Priya Mehta",
      title: "CEO, CodeVista",
      text:
        "Aesos transformed our legacy system into a modern, cloud-based platform. Their team was incredibly responsive, and the quality of work exceeded our expectations.",
    },
    {
      image: testimonial2,
      name: "Rajiv Bhandari",
      title: "IT Manager, Edulite Academy",
      text:
        "We partnered with Aesos to build our e-learning platform. The result was a user-friendly, scalable solution that our students and faculty love using daily.",
    },
    {
      image: testimonial3,
      name: "Sana Shaikh",
      title: "Digital Consultant",
      text:
        "The team at Aesos is technically skilled and genuinely passionate. They delivered my mobile app on time, and their post-launch support has been excellent.",
    },
    {
      image: testimonial4,
      name: "Ankit Verma",
      title: "Founder, NexEdge Solutions",
      text:
        "Working with Aesos was a seamless experience. They brought our vision to life with great attention to detail and delivered a secure and elegant web application.",
    },
  ];

  return (
    <div className="container-fluid testimonial py-5 mb-5" id="testimonial">
      <div className="container">
        <div
          className="text-center mx-auto pb-5"
          data-aos="fade-up"
          style={{ maxWidth: "600px" }}
        >
          <h5 className="text-primary">Our Testimonial</h5>
          <h1>What Our Clients Say</h1>
        </div>
        <Swiper
          modules={[Autoplay]}
          spaceBetween={30}
          slidesPerView={3}
          loop={true}
          autoplay={{ delay: 3000 }}
          data-aos="fade-up"
          breakpoints={{
            0: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            992: { slidesPerView: 3 },
          }}
        >
          {testimonials.map(({ image, name, title, text }, index) => (
            <SwiperSlide key={index}>
              <TestimonialCard
                image={image}
                name={name}
                title={title}
                text={text}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default Testimonial;
